import React from 'react';
import { baseUrl } from '../baseUrl';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
// import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

// import PlusOneIcon from '@mui/icons-material/PlusOne';
// import Card from '@mui/material/Card';

export default function BannerImage({selectedImage,...props}) {
    // console.log('ghj:',selectedImage);
    const [open, setOpen] = useState(false)
    // const [category, setCategory] = useState('Banner Image')
    const [id_no, setId_no] = useState('')


    const imageContainerStyle = {
        width: '100%',
        height: '200px', // Adjust the height as per your requirements
        overflow: 'hidden', // Hide any overflowing content
        position: 'relative', // Needed for centering the image
    };


    const handleClickDelete = (id) => {
        setOpen(true)
        setId_no(id)
    };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    async function handleOkay () {
        try {
            // console.log(id_no);
            const response = await axios.post(`${baseUrl}deletesongs`, { "id_no": id_no, 'type': 2 });
            const data = await response.data;
            if (data.status.code === 200) {
                setOpen(false);
                window.location.reload(true);
            }else{
                setOpen(false);
                alert(data.status.message)
            }
        }
        catch {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
            setOpen(false);
        }
    };

    const handleSelectBannerImage = async(id) =>{
        try {
            const response = await axios.post(`${baseUrl}changeBackgroundImage`, { "backgroundImage_id": id});
            const data = await response.data;
            if (data.status.code === 200) {
                alert('Banner image changes')
                window.location.reload(true);
            }else{
                alert(data.status.message)
            }
        }
        catch (e){
            console.log('Error is:',e);
        }
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5,
            slidesToSlide: 5 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 3,
            slidesToSlide: 3 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 767, min: 464 },
            items: 2,
            slidesToSlide: 1 // optional, default to 1.
        }
    };



    return (
        <>
            {/* delete bannner image */}
            <Dialog open={open} >
                <DialogTitle>Delete Banner Image</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this banner image? Once deleted, the image cannot be recovered.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setOpen(false);}}>Cancel</Button>
                    <Button onClick={()=>{handleOkay()}}>Okay</Button>
                </DialogActions>
            </Dialog>


            <div className="parent" >
                <Carousel
                    responsive={responsive}
                    autoPlay={true}
                    draggable={false}
                    swipeable={false}
                    showDots={true}
                    infinite={true}
                    partialVisible={false}
                    dotListClass="custom-dot-list-style"
                >
                {props?.Images?.map((item) => (
                    <div className="slider" key={item.id} >
                            <Button sx={{padding:0}} onClick={()=>{handleSelectBannerImage(item.id)}}>
                                <div style={{...imageContainerStyle,border: selectedImage === item.image ? '5px solid red' : 'none' }}>
                                    <img src={item.image} alt="Image" style={{borderRadius: '15px', width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                            </Button>
                            <CardActions sx={{ justifyContent: 'center', marginTop: 'auto' }}>
                                <Button onClick={() => handleClickDelete(item.id)} variant="outlined" startIcon={<DeleteIcon />}>
                                    Delete
                                </Button>
                            </CardActions>
                        </div>
                    ))
                }
                </Carousel>
            </div>

        </>
    );
}
